import { useQuery } from 'react-query';
import { useLocation, useParams } from 'react-router-dom';

// Our Axios Instance
import axiosInstance from 'services/API/API';

// Api URLS
import { getUserLiabilitiesUrl } from 'shared/api-urls';

// QUery keys
import { USER_AUTOS } from 'shared/query-keys';

// our routes
import { LIABILITY_ADDITIONAL_ROUTE } from 'routes';

// Our utils
import getNonNullValues from 'shared/utils/clientOnboarding/getNonNullValues';

function useGetUserAutoLiability() {
	const location = useLocation();
	const { pathname } = location;
	const { tradeLineId } = useParams();

	const isManualRoute = pathname.includes(LIABILITY_ADDITIONAL_ROUTE);

	// if this is a isManualRoute do not do the data binding

	const urlWithTradeLineId = `${getUserLiabilitiesUrl}${tradeLineId}`;

	return useQuery(
		[USER_AUTOS, tradeLineId],
		async () => {
			const response = await axiosInstance.get(urlWithTradeLineId);

			// This is the data from Sora Api which includes meta
			const Liability = response.data;

			// This is the actual mortgage Data
			const autoData = Liability.data;

			return autoData;
		},
		{
			enabled: !isManualRoute,
			refetchOnWindowFocus: false,
			select: ({
				expectedPayOffDate,
				dataSource,
				financialGoal,
				interestRate,
				lender,
				loanType,
				monthlyPay,
				mfiDataSource,
				outstandingBalance,
				tenureMonth,
				vehicleInfo,
				rateManuallyUpdated
			}) => {
				// get rid of garbage data before giving it to AutoLiability Component
				const autoDataWithoutNullValues = getNonNullValues({
					expectedPayOffDate,
					dataSource,
					financialGoal,
					interestRate,
					lender,
					loanType,
					monthlyPay,
					mfiDataSource,
					outstandingBalance,
					tenureMonth,
					rateManuallyUpdated,
					vehicleInfo
				});
				return autoDataWithoutNullValues;
			}
		}
	);
}

export default useGetUserAutoLiability;
